import type { DataSchema } from 'types';
import { TABLE_CELL_TYPE } from 'types/enums';

export const modulesDataScheme = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  number: {
    label: 'number',
    type: TABLE_CELL_TYPE.NUMBER,
    translationKey: 'table.header.number',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  name_Cs: {
    label: 'name_cs',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
    hidden: true,
  },
  name_En: {
    label: 'name_en',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
    hidden: true,
  },
  name_Sk: {
    label: 'name_sk',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
    hidden: true,
  },
  isFlowVisible: {
    label: 'isFlowVisible',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'table.header.flow',
  },
  isHeliosVisible: {
    label: 'isHeliosVisible',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'table.header.helios',
  },
  pageRowCount: {
    label: 'pageRowCount',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.rowCount',
  },
  icon: {
    label: 'icon',
    type: TABLE_CELL_TYPE.ICON,
    translationKey: 'table.header.icon',
  },
  assistants: {
    label: 'assistants',
    type: TABLE_CELL_TYPE.NODE,
    translationKey: 'table.header.assistants',
  },
  order: {
    label: 'order',
    type: TABLE_CELL_TYPE.NUMBER,
    translationKey: 'table.header.order',
    hidden: true,
  },
  isPinned: {
    label: 'isPinned',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'table.header.isPinned',
    hidden: true,
  },
  showRecordPreview: {
    label: 'showRecordPreview',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'core.modules.showRecordPreview',
    hidden: true,
  },
  dashboardId: {
    label: 'dashboardId',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.dashboardId',
    hidden: true,
  },
  parent: {
    label: 'parent',
    type: TABLE_CELL_TYPE.NODE,
    translationKey: 'table.header.parent',
    hidden: true,
  },
  childs: {
    label: 'childs',
    type: TABLE_CELL_TYPE.NODE,
    translationKey: 'table.header.childs',
    hidden: true,
  },
} satisfies DataSchema;
